module.exports = __webpack_public_path__ + "img/huanjiebiandong.6d953c9c.png";